import { Card } from "@dealer-center/core-components";
import styled from "styled-components";
export const StyledCard = styled(Card)`
  .panel-title {
    width: 100%;
  }
`;
